export function toNumber(value: unknown): number | null {
  if (value == null || value === '') return null;
  const num = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(num) ? num : null;
}

export function formatAmount(
  value: unknown,
  decimals = 2,
  currencySymbol = '£',
): string {
  const num = toNumber(value);
  if (num == null) return 'N/A';
  return `${currencySymbol}${num.toFixed(decimals)}`;
}

export function formatMoney(
  value: number | string | null | undefined,
  currencySymbol = '£',
): string {
  return formatAmount(value, 2, currencySymbol);
}
